var _rect, _path, _rect2, _path2, _path3, _path4, _path5, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.2987,
    y: 12.9088,
    width: 2.93938,
    height: 4.84241,
    rx: 1.33595,
    stroke: "#2E2E2E",
    strokeWidth: 1.81818
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4433 22.0178C23.4433 21.2182 23.8846 20.5526 24.5376 20.3068C25.5569 19.9233 26.7833 19.5694 27.7675 19.5694C28.7517 19.5694 29.9781 19.9233 30.9974 20.3068C31.6504 20.5526 32.0917 21.2182 32.0917 22.0178V25.3634H23.4433V22.0178Z",
    stroke: "#2E2E2E",
    strokeWidth: 1.81818
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.9086,
    y: 31.0908,
    width: 24.1818,
    height: 32.1818,
    rx: 2.09091,
    transform: "rotate(-90 3.9086 31.0908)",
    stroke: "#2E2E2E",
    strokeWidth: 1.81818
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1292 16.2498C18.5587 15.2617 17.7381 14.4411 16.75 13.8707C15.7619 13.3002 14.641 12.9998 13.5 12.9998L13.5 19.4998L19.1292 16.2498Z",
    fill: "currentColor",
    stroke: "#2E2E2E",
    strokeWidth: 1.81818,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12.9998C12.359 12.9998 11.2381 13.3002 10.25 13.8707C9.26187 14.4411 8.44133 15.2617 7.87083 16.2498C7.30034 17.2379 7 18.3588 7 19.4998C7 20.6408 7.30034 21.7617 7.87083 22.7498C8.44133 23.7379 9.26187 24.5585 10.25 25.129C11.2381 25.6995 12.359 25.9998 13.5 25.9998C14.641 25.9998 15.7619 25.6995 16.75 25.129C17.7381 24.5585 18.5587 23.7379 19.1292 22.7498L13.5 19.4998L13.5 12.9998Z",
    stroke: "#2E2E2E",
    strokeWidth: 1.81818,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12.9998C12.0691 12.9998 10.6782 13.472 9.54305 14.343C8.40786 15.2141 7.59182 16.4354 7.22148 17.8175C6.85114 19.1996 6.94721 20.6653 7.49478 21.9873C8.04235 23.3092 9.01083 24.4135 10.25 25.129C11.4892 25.8444 12.9298 26.131 14.3484 25.9442C15.7671 25.7574 17.0844 25.1078 18.0962 24.096C19.108 23.0842 19.7576 21.7669 19.9444 20.3482C20.1312 18.9296 19.8446 17.489 19.1292 16.2498L13.5 19.4998L13.5 12.9998Z",
    stroke: "#2E2E2E",
    strokeWidth: 1.81818,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12.9998C12.6464 12.9998 11.8012 13.1679 11.0126 13.4946C10.2239 13.8213 9.50739 14.3 8.9038 14.9036C8.30022 15.5072 7.82144 16.2238 7.49478 17.0124C7.16813 17.801 7 18.6462 7 19.4998C7 20.3534 7.16813 21.1986 7.49478 21.9873C7.82144 22.7759 8.30022 23.4924 8.90381 24.096C9.50739 24.6996 10.2239 25.1784 11.0126 25.505C11.8012 25.8317 12.6464 25.9998 13.5 25.9998L13.5 19.4998L13.5 12.9998Z",
    stroke: "#2E2E2E",
    strokeWidth: 1.81818,
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.99951,
    y1: 34.0908,
    x2: 30.9995,
    y2: 34.0908,
    stroke: "#2E2E2E",
    strokeWidth: 1.81818
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessManagement);
export default __webpack_public_path__ + "static/media/Business Management.a9310a287770d89861a18b72b4a592ce.svg";
export { ForwardRef as ReactComponent };